<div class="dialog-wrapper">
  <div class="dismiss-button-placeholder">
    <button class="dismiss-button" (click)="dialogRef.close()">
      <i class="material-icons icon">close</i>
    </button>
  </div>
  <div class="options-placeholder">
    @for (option of options; track option) {
      <app-status-selector-option
        [value]="option.id"
        [label]="generateLabel(option)"
        [isFavouriteable]="option.isFavourite !== undefined"
        [isFavourite]="option.isFavourite"
        [isSelected]="option.id == selected?.id"
        (selectEvent)="select(option)"
        (favouriteEvent)="toggleFavourite(option)"
      ></app-status-selector-option>
    }
  </div>
  <div class="dialog-actions">
    <button color="primary" (click)="submit(selected)" mat-flat-button>Confirm</button>
  </div>
</div>
